import { useEffect, useRef } from "react";
import { CalendarCheck } from "lucide-react";
import { BOOKING_URL } from "@/data/menu";

const LOCALE_PHOTOS = [
  { src: "/assets/baianeira/locale-1.jpg", alt: "Neon Mais amor por favor nel locale" },
  { src: "/assets/baianeira/locale-2.jpg", alt: "Sala con lampade di rattan e murale della giungla" },
  { src: "/assets/baianeira/locale-3.jpg", alt: "Specchio ad arco con neon Baianeira" },
  { src: "/assets/baianeira/locale-4.jpg", alt: "Lampade tessili sospese tra le piante" },
  { src: "/assets/baianeira/locale-5.jpg", alt: "Angolo del locale con poltrone turchesi" },
];

export const LocaleShowcase = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (v && v.paused) v.play().catch(() => {});
  }, []);

  return (
    <section
      aria-label="Il locale Baianeira"
      data-testid="locale-showcase"
      className="overflow-hidden border-t border-[#D4AF37]/15 bg-[#050505] py-12 md:py-16"
    >
    <p className="px-5 text-center text-[10px] font-semibold tracking-[0.4em] text-[#D4AF37]">IL LOCALE</p>
    <h2 className="mt-3 px-5 text-center font-display text-3xl text-[#F5F2E9] md:text-5xl">
      Un&rsquo;oasi tropicale <em className="gold-shimmer not-italic">a Cinecittà</em>
    </h2>

    <div className="relative mx-auto mt-8 max-w-4xl px-5">
      <video
        ref={videoRef}
        data-testid="locale-video"
        src="/assets/baianeira/locale-clip.mp4"
        poster="/assets/baianeira/locale-2.jpg"
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        onCanPlay={() => { const v = videoRef.current; if (v && v.paused) v.play().catch(() => {}); }}
        className="mx-auto h-[440px] w-auto max-w-full border border-[#D4AF37]/30 object-cover md:h-[540px]"
      />
      <a
        href={BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="locale-prenota-button"
        className="absolute bottom-4 right-8 flex items-center gap-2 bg-[#25D366] px-4 py-3 text-[10px] font-bold tracking-[0.15em] text-[#05220f] shadow-lg transition-transform active:scale-[0.97] md:text-xs"
      >
        <CalendarCheck size={15} /> PRENOTA UN TAVOLO
      </a>
    </div>

    <div className="mx-auto mt-6 flex max-w-6xl snap-x gap-3 overflow-x-auto px-5 pb-2 [scrollbar-width:none] md:mt-8 md:grid md:grid-cols-5 md:gap-4 md:overflow-visible [&::-webkit-scrollbar]:hidden">
      {LOCALE_PHOTOS.map((p, i) => (
        <img
          key={p.src}
          src={p.src}
          alt={p.alt}
          loading="lazy"
          data-testid={`locale-photo-${i}`}
          className="h-44 w-36 shrink-0 snap-center border border-[#D4AF37]/25 object-cover md:h-40 md:w-full"
        />
      ))}
    </div>
  </section>
  );
};

export default LocaleShowcase;
